// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"94834670","291":"f52b2004","787":"5c7562c1"}[chunkId] + ".chunk.js";
};